webpackJsonp([215],{

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternTable_vue__ = __webpack_require__(2518);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82c3cbb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternTable_vue__ = __webpack_require__(3194);
function injectStyle (ssrContext) {
  __webpack_require__(3188)
  __webpack_require__(3190)
  this["$style"] = __webpack_require__(3192)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-82c3cbb2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuditInternTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82c3cbb2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuditInternTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * ElementUI 日期选择组件的参数
 * @Author: anker.wang
 * @Date: 2018-01-08 11:27:07
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-01-08 11:28:27
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dateTimePickerOptions: {
        shortcuts: [{
          text: '一周后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天后',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '明天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '今天',
          onClick: function onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '三天前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick: function onClick(picker) {
            var date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      dateTimePickerRangeOptions: {
        shortcuts: [{
          text: '最近1周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近6个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近1年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近2年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 730);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近3年',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1095);
            picker.$emit('pick', [start, end]);
          }
        }]
      }
    };
  }
});

/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return auditInternPermissionMixin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

var baseExportHeader = [{ key: 'id', text: '账号ID' }, { key: 'name', text: '账号' }, { key: 'realname', text: '姓名' }, { key: 'employment_type', text: '人员性质' }, { key: 'office_location', text: '办公地点' }, { key: 'status', text: '状态' }, { key: 'phone', text: '手机号' }, { key: 'mail_address', text: '个人邮箱' }, { key: 'school', text: '目前所在院校' }, { key: 'major', text: '专业' }, { key: 'education_level', text: '学历' }, { key: 'grade_level', text: '当前学年段' }, { key: 'student_card_photos', text: '学生证照片' }, { key: 'contract_start_date', text: '合同开始时间' }, { key: 'contract_end_date', text: '合同结束时间' }, { key: 'remark', text: '备注' }, { key: 'participant_customers', text: '累计参与客户(系统自动维护,不可修改)' }, { key: 'participant_projects', text: '累计参与项目(系统自动维护,不可修改)' }];

// 权限控制方法
var auditInternPermissionMixin = {
  methods: {
    /**
     * 判断是否允许查看实习生列表
     * @returns {boolean}
     */
    allowViewInternTable: function allowViewInternTable() {
      return filter.hasPermission(40001);
    },

    /**
     * 判断是否允许编辑/查看基础资料
     * @returns {boolean}
     */
    allowViewEditBase: function allowViewEditBase() {
      return filter.hasPermission(40002);
    },

    /**
     * 判断是否允许编辑/查看隐私信息
     * @returns {boolean}
     */
    allowViewEditPrivate: function allowViewEditPrivate() {
      return filter.hasPermission(40003);
    },

    /**
     * 判断是否允许编辑/查看资源控制信息
     * @returns {boolean}
     */
    allowViewEditResource: function allowViewEditResource() {
      return filter.hasPermission(40004);
    },

    /**
     * 判断是否允许编辑/查看分配用户资源
     * @returns {boolean}
     */
    allowViewEditUserResource: function allowViewEditUserResource() {
      return filter.hasPermission(40005);
    },

    /**
     * 判断是否允许添加实习生账号
     * @returns {boolean}
     */
    allowCreateIntern: function allowCreateIntern() {
      return filter.hasPermission(40006);
    },

    /**
     * 判断是否允许导出实习生隐私信息
     * @returns {boolean}
     */
    allowExportPrivateData: function allowExportPrivateData() {
      return filter.hasPermission(40007);
    }
  },
  computed: {
    /**
     * 根据权限自动选择默认标签页
     * @returns {string}
     */
    getActiveTab: function getActiveTab() {
      if (this.allowViewEditBase()) {
        return 'baseInfo';
      } else if (this.allowViewEditPrivate()) {
        return 'privateInfo';
      } else if (this.allowViewEditResource()) {
        return 'resourceInfo';
      } else if (this.allowViewEditUserResource()) {
        return 'userResourceInfo';
      } else {
        return '';
      }
    }
  }
};

/* harmony default export */ __webpack_exports__["b"] = ({
  data: function data() {
    var _this = this;

    return {
      tableColumns: [{ prop: 'id', label: '账号ID', minWidth: '90' }, { prop: 'realname', label: '姓名', minWidth: '100' }, { prop: 'name', label: '账号', minWidth: '120' }, { prop: 'phone', label: '手机号', minWidth: '120' }, { prop: 'employment_type', label: '人员性质', minWidth: '80', formatter: function formatter(row) {
          return _.get(_this.employmentTypeMap, row.employment_type, '-');
        } }, { prop: 'participant_customers', label: '累计参与客户', width: '200' }, { prop: 'status', label: '用户状态', minWidth: '100', formatter: function formatter(row) {
          return _.get(_this.statusMap, row.status, '-');
        } }, { prop: 'total_work_days', label: '累计出勤天数', minWidth: '100' }],
      exportBaseHeader: baseExportHeader,
      exportFullHeader: [].concat(baseExportHeader, [{ key: 'assigned_customers', text: '客户资源' }, { key: 'ui_roles', text: 'UI角色' }, { key: 'api_roles', text: 'API角色' }, { key: 'id_number', text: '身份证号' }, { key: 'id_card_front_photo', text: '身份证正面照片' }, { key: 'id_card_back_photo', text: '身份证反面照片' }, { key: 'bank_name', text: '银行名称' }, { key: 'bank_branch_name', text: '支行信息' }, { key: 'bank_card_number', text: '银行卡号' }, { key: 'bank_card_photo', text: '银行卡照片' }])
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    employmentTypeMap: function employmentTypeMap(state) {
      return state.auditIntern.employmentTypeMap;
    },
    educationLevelMap: function educationLevelMap(state) {
      return state.auditIntern.educationLevelMap;
    },
    officeLocationMap: function officeLocationMap(state) {
      return state.auditIntern.officeLocationMap;
    },
    gradeLevelMap: function gradeLevelMap(state) {
      return state.auditIntern.gradeLevelMap;
    },
    statusMap: function statusMap(state) {
      return state.auditIntern.statusMap;
    }
  })),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, auditInternPermissionMixin.methods)
});

/***/ }),

/***/ 2518:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__audit_intern_mixins_js__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__core_components_RemoteSelect_vue__ = __webpack_require__(248);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { RemoteSelect: __WEBPACK_IMPORTED_MODULE_5__core_components_RemoteSelect_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__core_mixins_dateTimePicker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__audit_intern_mixins_js__["b" /* default */]],
  data: function data() {
    return {
      search: {
        id: null,
        name: null,
        realname: null,
        phone: null,
        employment_type: null,
        status: null,
        participant_customer: []
      },
      dialogCfg: {
        title: '',
        dialogVisible: false,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: function downDemoFile() {},
        createCrontab: function createCrontab() {}
      }
    };
  },

  computed: Vuex.mapState({}),
  created: function created() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), request.map(['getCustomerTable', 'getCustomerDetail', 'exportInternBaseInfoApi', 'exportInternFullInfoApi']), {
    isSuperAdmin: function isSuperAdmin() {
      return filter.superPermission();
    },

    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {
      return request.common('queryInternTableApi', params).then(function (response) {
        response.data.data = response.data.data.map(function (item) {
          item.participant_customers = item.participant_customers.map(function (customer) {
            return customer.name + '/' + customer.id;
          }).join(', ');
          return item;
        });
        return response;
      });
    },
    allowEditInfo: function allowEditInfo() {
      return this.allowViewEditBase() || this.allowViewEditPrivate() || this.allowViewEditResource() || this.allowViewEditUserResource();
    },
    qualityHref: function qualityHref(row) {
      return '/audit-intern/performance?intern_user_id=' + row.id;
    },
    activeAdmin: function activeAdmin(row) {
      var _this = this;

      request.common('activeInternStatusBaseApi', { id: row.id }).then(function () {
        _this.$message.success('用户状态激活成功');
        _this.onRefresh();
      });
    },
    convertToFulltime: function convertToFulltime(row) {
      var _this2 = this;

      this.$confirm('\u786E\u8BA4\u5C06\u8D26\u53F7\u300C' + row.name + '\u300D\u8F6C\u4E3A\u5168\u804C\u7BA1\u7406\u5458\uFF1F\u8F6C\u540E\u5C06\u4E0D\u518D\u51FA\u73B0\u5728\u5B9E\u4E60\u751F\u5217\u8868\uFF0C\u5BA2\u6237\u8D44\u6E90\u4E0E\u89D2\u8272\u4F1A\u4FDD\u7559\u3002', '转为全职', {
        type: 'warning',
        confirmButtonText: '确认转换',
        cancelButtonText: '取消'
      }).then(function () {
        return request.common('convertInternToFulltimeApi', { id: row.id });
      }).then(function () {
        _this2.$message.success('已转为全职账号');
        _this2.onRefresh();
      }).catch(function () {});
    },
    onExportBaseInfo: function onExportBaseInfo() {
      var _this3 = this;

      this.$export('导出实习生基础信息', {
        fileHeader: this.exportBaseHeader,
        total: this.pagination.total,
        request: this.exportInternBaseInfoApi,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["b" /* removeEmptyParams */])(Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["c" /* trimParams */])(_.cloneDeep(this.search))),
        getResponseData: function getResponseData(data) {
          data.data = _this3.handleExportData(data.data);
          return data;
        }
      });
    },
    onExportFullInfo: function onExportFullInfo() {
      var _this4 = this;

      this.$export('导出实习生全部信息', {
        fileHeader: this.exportFullHeader,
        total: this.pagination.total,
        request: this.exportInternFullInfoApi,
        requestParams: Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["b" /* removeEmptyParams */])(Object(__WEBPACK_IMPORTED_MODULE_4__core_mixins_table_v3__["c" /* trimParams */])(_.cloneDeep(this.search))),
        getResponseData: function getResponseData(data) {
          data.data = _this4.handleExportData(data.data);
          return data;
        }
      });
    },
    handleExportData: function handleExportData(data) {
      var _this5 = this;

      data.forEach(function (row) {
        row.employment_type = _.get(_this5.employmentTypeMap, _.get(row, 'employment_type'), '');
        row.status = _.get(_this5.statusMap, _.get(row, 'status'), '');
        row.grade_level = _.get(_this5.gradeLevelMap, _.get(row, 'grade_level'), '');
        row.education_level = _.get(_this5.educationLevelMap, _.get(row, 'education_level'), '');
        row.office_location = _.get(_this5.officeLocationMap, _.get(row, 'office_location'), '');
        row.contract_start_date = _this5.formatDateStr(_.get(row, 'contract_start_date', ''));
        row.contract_end_date = _this5.formatDateStr(_.get(row, 'contract_end_date', ''));

        row.student_card_photos = Array.isArray(_.get(row, 'student_card_photos')) ? row.student_card_photos : [];
        row.assigned_customers = Array.isArray(_.get(row, 'assigned_customers')) ? row.assigned_customers : [];
        row.ui_roles = Array.isArray(_.get(row, 'ui_roles')) ? row.ui_roles : [];
        row.api_roles = Array.isArray(_.get(row, 'api_roles')) ? row.api_roles : [];
        row.participant_customers = Array.isArray(_.get(row, 'participant_customers')) ? row.participant_customers : [];
        row.participant_projects = Array.isArray(_.get(row, 'participant_projects')) ? row.participant_projects : [];
        row.bank_card_photo = Array.isArray(_.get(row, 'bank_card_photo')) ? row.bank_card_photo : [];
        row.student_card_photos = row.student_card_photos.join(', ');
        row.bank_card_photo = row.bank_card_photo.join(', ');
        row.assigned_customers = row.assigned_customers.map(function (item) {
          return item.name + '/' + item.id;
        }).join(',');
        row.ui_roles = row.ui_roles.map(function (item) {
          return item.name + '/' + item.id;
        }).join(',');
        row.api_roles = row.api_roles.map(function (item) {
          return item.name + '/' + item.id;
        }).join(',');
        row.participant_customers = row.participant_customers.map(function (item) {
          return item.name + '/' + item.id;
        }).join(',');
        row.participant_projects = row.participant_projects.map(function (item) {
          return item.name + '/' + item.id;
        }).join(',');
      });
      return data;
    },
    formatDateStr: function formatDateStr(str) {
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'sj:';

      if (str) {
        return prefix + str.slice(0, 10);
      }
      return '';
    },
    batchAddIntern: function batchAddIntern() {
      var _this6 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.dialogCfg, {
        title: '批量添加实习生',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: function downDemoFile() {
          return _this6.downBatchCreateInternDemo();
        },
        createCrontab: function createCrontab() {
          return _this6.handleBatchAddSubmit();
        }
      });
    },
    batchEditInternBase: function batchEditInternBase() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.dialogCfg, {
        title: '批量修改实习生基础资料',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: function downDemoFile() {
          return _this7.downBatchEditBaseDemo();
        },
        createCrontab: function createCrontab() {
          return _this7.handleBatchEditBaseSubmit();
        }
      });
    },
    batchEditInternPrivate: function batchEditInternPrivate() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.dialogCfg, {
        title: '批量修改实习生隐私信息',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: function downDemoFile() {
          return _this8.downBatchEditPrivateDemo();
        },
        createCrontab: function createCrontab() {
          return _this8.handleBatchEditPriSubmit();
        }
      });
    },
    batchEditInternResource: function batchEditInternResource() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.dialogCfg, {
        title: '批量修改实习生资源限制',
        dialogVisible: true,
        batchAddLoading: false,
        fileList: [],
        downDemoFile: function downDemoFile() {
          return _this9.downBatchEditResourceDemo();
        },
        createCrontab: function createCrontab() {
          return _this9.handleBatchEditResSubmit();
        }
      });
    },
    closeDialog: function closeDialog() {
      this.dialogCfg.dialogVisible = false;
      this.$refs.batchAddForm.resetFields();
      this.dialogCfg.fileList = [];
    },
    handleDownDemoFile: function handleDownDemoFile() {
      this.dialogCfg.downDemoFile();
    },
    handleFileChange: function handleFileChange(file, fileList) {
      this.dialogCfg.fileList = fileList;
    },
    downBatchCreateInternDemo: function downBatchCreateInternDemo() {
      var demo = [{
        name: '实习生张三',
        password: 'User@123',
        realname: '张三',
        employment_type: '兼职',
        office_location: '临港',
        phone: '13112345678',
        mail_address: 'person@example.com',
        school: '上海xxx大学',
        major: 'xxx专业',
        education_level: '本科',
        grade_level: '大三',
        student_card_photos: 'a.jpg,b.jpg,c.jpg',
        contract_start_date: 'sj:2025-11-01',
        contract_end_date: 'sj:2026-03-01',
        remark: '这里是备注文字',
        id_number: 'xxxxxxx',
        id_card_front_photo: '正面.jpg',
        id_card_back_photo: '反面.jpg',
        bank_name: '中国工商银行',
        bank_branch_name: 'xxx支行信息',
        bank_card_number: '62128888888888',
        bank_card_photo: '银行卡1.jpg,银行卡2.jpg'
      }, {
        name: '登录账号名,必填',
        password: '选填,留空为默认值:User@123',
        realname: '必填',
        employment_type: '必填,可选参数: 实习生/兼职',
        office_location: '必填,可选参数: 临港,陆家嘴,客户公司,线上,成都,其他',
        phone: '必填',
        mail_address: '选填',
        school: '选填',
        major: '选填',
        education_level: '选填',
        grade_level: '选填,可选参数: 大一、大二、大三、大四、研一、研二、研三、已毕业',
        student_card_photos: '照片链接,多张照片使用,分隔',
        contract_start_date: '必填',
        contract_end_date: '必填',
        remark: '选填',
        id_number: '选填',
        id_card_front_photo: '选填',
        id_card_back_photo: '选填',
        bank_name: '选填',
        bank_branch_name: '选填',
        bank_card_number: '选填',
        bank_card_photo: '选填,多张照片使用,分隔'
      }];
      var fileHeader = [{ key: 'name', text: '账号' }, { key: 'password', text: '密码' }, { key: 'realname', text: '姓名' }, { key: 'employment_type', text: '人员性质' }, { key: 'office_location', text: '办公地点' }, { key: 'phone', text: '手机号' }, { key: 'mail_address', text: '个人邮箱' }, { key: 'school', text: '目前所在院校' }, { key: 'major', text: '专业' }, { key: 'education_level', text: '学历' }, { key: 'grade_level', text: '当前学年段' }, { key: 'student_card_photos', text: '学生证照片' }, { key: 'contract_start_date', text: '合同开始时间' }, { key: 'contract_end_date', text: '合同结束时间' }, { key: 'remark', text: '备注' }, { key: 'id_number', text: '身份证号' }, { key: 'id_card_front_photo', text: '身份证正面照片' }, { key: 'id_card_back_photo', text: '身份证反面照片' }, { key: 'bank_name', text: '银行名称' }, { key: 'bank_branch_name', text: '支行信息' }, { key: 'bank_card_number', text: '银行卡号' }, { key: 'bank_card_photo', text: '银行卡照片' }];
      this.$export(this.dialogCfg.title + '模板', demo, { fileHeader: fileHeader });
    },
    downBatchEditBaseDemo: function downBatchEditBaseDemo() {
      var demo = [{
        id: '9999999',
        name: '实习生张三',
        password: '',
        realname: '张三',
        employment_type: '兼职',
        office_location: '临港',
        status: '活跃',
        phone: '13112345678',
        mail_address: 'person@example.com',
        school: '上海xxx大学',
        major: 'xxx专业',
        education_level: '本科',
        grade_level: '大三',
        student_card_photos: 'a.jpg,b.jpg,c.jpg',
        contract_start_date: 'sj:2025-11-01',
        contract_end_date: 'sj:2026-03-01',
        remark: '这里是备注文字'
      }, {
        id: '账号ID,必填',
        name: '登录账号名,选填',
        password: '选填,无需修改时留空',
        realname: '必填',
        employment_type: '必填,可选参数: 实习生/兼职',
        office_location: '必填,可选参数: 临港,陆家嘴,客户公司,线上,成都,其他',
        status: '必填,可选参数: 活跃/待机/离职',
        phone: '必填',
        mail_address: '选填',
        school: '选填',
        major: '选填',
        education_level: '选填',
        grade_level: '选填,可选参数: 大一、大二、大三、大四、研一、研二、研三、已毕业',
        student_card_photos: '照片链接,多张照片使用,分隔',
        contract_start_date: '必填',
        contract_end_date: '必填',
        remark: '选填'
      }];
      var fileHeader = [{ key: 'id', text: '账号ID' }, { key: 'name', text: '账号' }, { key: 'password', text: '密码' }, { key: 'realname', text: '姓名' }, { key: 'employment_type', text: '人员性质' }, { key: 'office_location', text: '办公地点' }, { key: 'status', text: '状态' }, { key: 'phone', text: '手机号' }, { key: 'mail_address', text: '个人邮箱' }, { key: 'school', text: '目前所在院校' }, { key: 'major', text: '专业' }, { key: 'education_level', text: '学历' }, { key: 'grade_level', text: '当前学年段' }, { key: 'student_card_photos', text: '学生证照片' }, { key: 'contract_start_date', text: '合同开始时间' }, { key: 'contract_end_date', text: '合同结束时间' }, { key: 'remark', text: '备注' }];
      this.$export(this.dialogCfg.title + '模板', demo, { fileHeader: fileHeader });
    },
    downBatchEditPrivateDemo: function downBatchEditPrivateDemo() {
      var demo = [{
        id: '9999999',
        id_number: 'xxxxxxx',
        id_card_front_photo: '正面.jpg',
        id_card_back_photo: '反面.jpg',
        bank_name: '中国工商银行',
        bank_branch_name: 'xxx支行信息',
        bank_card_number: '62128888888888',
        bank_card_photo: '银行卡1.jpg,银行卡2.jpg'
      }, {
        id: '账号ID,必填',
        id_number: '必填',
        id_card_front_photo: '选填',
        id_card_back_photo: '选填',
        bank_name: '选填',
        bank_branch_name: '选填',
        bank_card_number: '选填',
        bank_card_photo: '选填,多张照片使用,分隔'
      }];
      var fileHeader = [{ key: 'id', text: '账号ID' }, { key: 'id_number', text: '身份证号' }, { key: 'id_card_front_photo', text: '身份证正面照片' }, { key: 'id_card_back_photo', text: '身份证反面照片' }, { key: 'bank_name', text: '银行名称' }, { key: 'bank_branch_name', text: '支行信息' }, { key: 'bank_card_number', text: '银行卡号' }, { key: 'bank_card_photo', text: '银行卡照片' }];
      this.$export(this.dialogCfg.title + '模板', demo, { fileHeader: fileHeader });
    },
    downBatchEditResourceDemo: function downBatchEditResourceDemo() {
      var demo = [{
        id: '9999999',
        assigned_customers: '联合利华/100,恰恰/101',
        ui_roles: '角色/1,角色/5',
        api_roles: '角色/6,角色/15'
      }, {
        id: '账号ID,必填',
        assigned_customers: '留空时重置客户资源为空',
        ui_roles: '留空时重置UI角色为空',
        api_roles: '留空时重置API角色为空'
      }];
      var fileHeader = [{ key: 'id', text: '账号ID' }, { key: 'assigned_customers', text: '客户资源' }, { key: 'ui_roles', text: 'UI角色' }, { key: 'api_roles', text: 'API角色' }];
      this.$export(this.dialogCfg.title + '模板', demo, { fileHeader: fileHeader });
    },
    handleBatchAddSubmit: function handleBatchAddSubmit() {
      var _this10 = this;

      var formData = new FormData();
      formData.append('file', this.dialogCfg.fileList[0].raw);
      request.common('batchCreateInternApi', formData).then(function (_ref) {
        var data = _ref.data;

        _this10.$message.success('任务创建成功');
        _this10.closeDialog();
      }).finally(function () {
        _this10.loading = false;
      });
    },
    handleBatchEditBaseSubmit: function handleBatchEditBaseSubmit() {
      var _this11 = this;

      var formData = new FormData();
      formData.append('file', this.dialogCfg.fileList[0].raw);
      formData.append('handle_mode', 'base_info');
      request.common('batchEditInternApi', formData).then(function (_ref2) {
        var data = _ref2.data;

        _this11.$message.success('任务创建成功');
        _this11.closeDialog();
      }).finally(function () {
        _this11.loading = false;
      });
    },
    handleBatchEditPriSubmit: function handleBatchEditPriSubmit() {
      var _this12 = this;

      var formData = new FormData();
      formData.append('file', this.dialogCfg.fileList[0].raw);
      formData.append('handle_mode', 'private_info');
      request.common('batchEditInternApi', formData).then(function (_ref3) {
        var data = _ref3.data;

        _this12.$message.success('任务创建成功');
        _this12.closeDialog();
      }).finally(function () {
        _this12.loading = false;
      });
    },
    handleBatchEditResSubmit: function handleBatchEditResSubmit() {
      var _this13 = this;

      var formData = new FormData();
      formData.append('file', this.dialogCfg.fileList[0].raw);
      formData.append('handle_mode', 'resource_info');
      request.common('batchEditInternApi', formData).then(function (_ref4) {
        var data = _ref4.data;

        _this13.$message.success('任务创建成功');
        _this13.closeDialog();
      }).finally(function () {
        _this13.loading = false;
      });
    }
  })
});

/***/ }),

/***/ 3188:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3189);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("c19e4cd2", content, true, {});

/***/ }),

/***/ 3189:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".ellipsis-cell{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.5}", "", {"version":3,"sources":["/workspace/src/views/audit-intern/pages/AuditInternTable.vue"],"names":[],"mappings":"AACA,eAAe,oBAAoB,4BAA4B,qBAAqB,aAAa,gBAAgB,uBAAuB,WAAW,eAAe,CACjK","file":"AuditInternTable.vue","sourcesContent":["\n.ellipsis-cell{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;line-clamp:2;overflow:hidden;text-overflow:ellipsis;width:100%;line-height:1.5\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3190:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3191);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("2063b489", content, true, {});

/***/ }),

/***/ 3191:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AuditInternTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3192:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("95f4d13e", content, true, {});

/***/ }),

/***/ 3193:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"AuditInternTable.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 3194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v("实习生管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',{attrs:{"collapse":false}},[_c('template',{slot:"header"},[_vm._v("搜索")]),_vm._v(" "),_c('el-form',{ref:"searchForm",attrs:{"model":_vm.search,"label-width":"96px","label-position":"right","size":"medium"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSearch()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('el-form-item',{attrs:{"label":"账号ID","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入账号ID","clearable":""},model:{value:(_vm.search.id),callback:function ($$v) {_vm.$set(_vm.search, "id", $$v)},expression:"search.id"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"账号","prop":"name"}},[_c('el-input',{attrs:{"placeholder":"请输入账号名","clearable":""},model:{value:(_vm.search.name),callback:function ($$v) {_vm.$set(_vm.search, "name", $$v)},expression:"search.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户姓名","prop":"realname"}},[_c('el-input',{attrs:{"placeholder":"请输入用户姓名","clearable":""},model:{value:(_vm.search.realname),callback:function ($$v) {_vm.$set(_vm.search, "realname", $$v)},expression:"search.realname"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"手机号","prop":"phone"}},[_c('el-input',{attrs:{"placeholder":"请输入手机号","clearable":""},model:{value:(_vm.search.phone),callback:function ($$v) {_vm.$set(_vm.search, "phone", $$v)},expression:"search.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"人员性质","prop":"employment_type"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择人员性质","clearable":""},model:{value:(_vm.search.employment_type),callback:function ($$v) {_vm.$set(_vm.search, "employment_type", $$v)},expression:"search.employment_type"}},_vm._l((_vm.employmentTypeMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户状态","prop":"status"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择","clearable":""},model:{value:(_vm.search.status),callback:function ($$v) {_vm.$set(_vm.search, "status", $$v)},expression:"search.status"}},_vm._l((_vm.statusMap),function(label,value){return _c('el-option',{key:value,attrs:{"label":label,"value":value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"参与客户","prop":"participant_customer"}},[_c('remote-select',{staticClass:"width-max",attrs:{"clearable":"","id-key":"number","label-key":"name","value-key":"id","placeholder":"请选择客户","query-request":_vm.getCustomerTable,"find-request":_vm.getCustomerDetail,"multiple":""},model:{value:(_vm.search.participant_customer),callback:function ($$v) {_vm.$set(_vm.search, "participant_customer", $$v)},expression:"search.participant_customer"}})],1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search","native-type":"submit"}},[_vm._v("搜索\n        ")]),_vm._v(" "),(_vm.allowViewInternTable())?_c('el-button',{attrs:{"icon":"sj-icon-export"},on:{"click":function($event){return _vm.onExportBaseInfo()}}},[_vm._v("\n          导出基础信息\n        ")]):_vm._e(),_vm._v(" "),(_vm.allowExportPrivateData())?_c('el-button',{attrs:{"icon":"sj-icon-export"},on:{"click":function($event){return _vm.onExportFullInfo()}}},[_vm._v("\n          导出全部信息\n        ")]):_vm._e()],1)],1)],2),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("列表")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('el-button',{attrs:{"type":"primary","size":"small","icon":"el-icon-refresh"},on:{"click":function($event){return _vm.onRefresh()}}})],1),_vm._v(" "),_c('div',{staticClass:"margin b15"},[_c('button-gutter',[_c('router-link',{attrs:{"to":'/audit-intern/create'}},[(_vm.allowCreateIntern())?_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"}},[_vm._v("新增用户\n          ")]):_vm._e()],1),_vm._v(" "),(_vm.allowCreateIntern())?_c('el-button',{attrs:{"type":"primary","icon":"sj-icon-add","size":"small"},on:{"click":function($event){return _vm.batchAddIntern()}}},[_vm._v("批量添加实习生\n        ")]):_vm._e(),_vm._v(" "),(_vm.allowViewEditBase())?_c('el-button',{attrs:{"type":"warning","icon":"sj-icon-add","size":"small"},on:{"click":function($event){return _vm.batchEditInternBase()}}},[_vm._v("批量修改基础资料\n        ")]):_vm._e(),_vm._v(" "),(_vm.allowViewEditPrivate())?_c('el-button',{attrs:{"type":"warning","icon":"sj-icon-add","size":"small"},on:{"click":function($event){return _vm.batchEditInternPrivate()}}},[_vm._v("批量修改隐私信息\n        ")]):_vm._e(),_vm._v(" "),(_vm.allowViewEditResource())?_c('el-button',{attrs:{"type":"warning","icon":"sj-icon-add","size":"small"},on:{"click":function($event){return _vm.batchEditInternResource()}}},[_vm._v("批量修改资源限制\n        ")]):_vm._e()],1)],1),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.tableColumns),function(attr){return [(attr.prop === 'participant_customers')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":scope.row[attr.prop] + '',"placement":"top"}},[_c('div',{staticClass:"ellipsis-cell"},[_vm._v(_vm._s(scope.row[attr.prop]))])])]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{attrs:{"fixed":"right","label":"操作","width":"160"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',[_c('el-link',{attrs:{"href":("/audit-intern/detail/" + (scope.row.id)),"type":"primary"}},[_vm._v("\n              详情\n            ")]),_vm._v(" "),_c('span',{staticClass:"el-divider el-divider--vertical"}),_vm._v(" "),(_vm.allowEditInfo())?_c('el-link',{attrs:{"href":("/audit-intern/update/" + (scope.row.id)),"type":"primary"}},[_vm._v("\n              修改\n            ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('el-link',{directives:[{name:"permission",rawName:"v-permission",value:(40013),expression:"40013"}],attrs:{"href":_vm.qualityHref(scope.row),"type":"primary"}},[_vm._v("\n              实习质量\n            ")])],1),_vm._v(" "),_c('div',[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.activeAdmin(scope.row)}}},[_vm._v("\n              激活\n            ")]),_vm._v(" "),(_vm.allowEditInfo())?_c('span',{staticClass:"el-divider el-divider--vertical"}):_vm._e(),_vm._v(" "),(_vm.allowEditInfo())?_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.convertToFulltime(scope.row)}}},[_vm._v("\n              转为全职\n            ")]):_vm._e()],1)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":_vm.dialogCfg.title,"visible":_vm.dialogCfg.dialogVisible,"width":"600px"},on:{"update:visible":function($event){return _vm.$set(_vm.dialogCfg, "dialogVisible", $event)},"close":function($event){return _vm.closeDialog()}}},[_c('el-form',{ref:"batchAddForm",attrs:{"label-width":"120px"}},[_c('el-form-item',{attrs:{"label":"下载模板"}},[_c('el-button',{attrs:{"type":"success","icon":"el-icon-download","size":"small"},on:{"click":function($event){return _vm.handleDownDemoFile()}}},[_vm._v("下载Excel模板\n        ")])],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"上传文件","prop":"file","rules":[{ required: true, message: '请上传Excel文件' }]}},[_c('el-upload',{ref:"upload",staticClass:"upload-demo",attrs:{"limit":1,"action":"#","auto-upload":false,"on-change":_vm.handleFileChange,"file-list":_vm.dialogCfg.fileList,"accept":".xlsx","drag":""}},[_c('i',{staticClass:"el-icon-upload"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("将Excel文件拖到此处，或"),_c('em',[_vm._v("点击上传")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("只能上传 xlsx 格式的文件\n          ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){return _vm.closeDialog()}}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","disabled":_vm.dialogCfg.fileList.length === 0,"loading":_vm.dialogCfg.batchAddLoading},on:{"click":function($event){return _vm.dialogCfg.createCrontab()}}},[_vm._v("确定上传\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/audit-intern-table.a5aacfb27b0371311fb0.js